
import StorageHelp from '@/utils/storageHelp'
import Vue from 'vue';
import {getSysDict} from "@/api/dpcManage/dpcManage";
/**
 * 系统基础资源
 * 包括字典和养老院配置
 *
 */
export const sysDict = {
  namespaced: true,
  state: {
    sysDict: StorageHelp.getStorage(StorageHelp.sysDict,'object') || {},
  },
  getters: {
    getSysDict(state) {
      return state.sysDict
    },
  },
  mutations: {
    setSysDict(state, sysDict) {
      state.sysDict = sysDict;
      StorageHelp.setStorage(StorageHelp.sysDict, sysDict,'object')
    }
  },
  actions: {
    getData({commit, rootGetters}) {
      getSysDict().then(resp=>{
          if(resp.data.resultCode === '1'){
            commit('setSysDict', resp.data.data);
            console.log(resp.data.data,'resp.data.data')
          }else{
            this.$message.error(`错误,${resp.data.msg}`);
          }
        })
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/sysDict.js